import Axios from './Base'

const API_URL = process.env.VUE_APP_API_URL

export default class Rsvp {
  constructor(token, wedId) {
    this.apiUrl = API_URL + '/v1/rsvp'
    this.wedId = token?.token_payload?.wed_id || wedId

    if (!token) this.axios = new Axios({ cache: false })
    else {
      this.token = `Bearer ${token.token}`

      this.axios = Axios({
        cache: false,
        authorization: this.token,
        wedId: this.wedId,
      })
    }
  }

  getRsvps() {
    return this.axios.get(`${this.apiUrl}?wed=${this.wedId}`)
  }

  deleteRsvp(id) {
    return this.axios.delete(`${this.apiUrl}?wed=${this.wedId}&id=${id}`)
  }

  deleteGuest(id) {
    return this.axios.delete(`${this.apiUrl}/guests?wed=${this.wedId}&id=${id}`)
  }

  getConfigsRsvp() {
    return this.axios.get(`${this.apiUrl}/configs?wed=${this.wedId}`)
  }

  setConfigRsvp(data) {
    return this.axios.post(`${this.apiUrl}/configs`, data)
  }

  downloadGuestsList(data) {
    return this.axios.get(
      `${this.apiUrl}/spreadsheets?wed=${this.wedId}&domain=${data}`
    )
  }

  createInvite(data) {
    return this.axios.post(`${this.apiUrl}/invites`, data)
  }

  editInvite(data, id) {
    return this.axios.put(`${this.apiUrl}/invites/${id}`, data)
  }

  searchInvite(search) {
    return this.axios
      .post(`${this.apiUrl}/invites/search?wed=${this.wedId}`, {
        search,
      })
      .then((response) => response.data)
  }

  getAllInvites(search) {
    return this.axios
      .get(`${this.apiUrl}/invites?wed=${this.wedId}`)
      .then((response) => response.data)
  }

  confirmInvite(id, last_4_digits) {
    return this.axios
      .post(`${this.apiUrl}/invites/${id}/confirm?wed=${this.wedId}`, {
        last_4_digits,
      })
      .then((response) => response.data)
  }

  answerInvite(id, data) {
    return this.axios
      .put(`${this.apiUrl}/invite/${id}?wed=${this.wedId}`, data)
      .then((response) => response.data)
  }

}
